import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';

import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';

import { httpPost } from '../services/http'
import { getTranslate } from '../db/Translate';

const DEFAULT_STATE = {
	footer: [],
	pages: []
}

const ScrollToTop = withRouter((props) => {
  const { history } = props

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location]);

  return null;
})


const Template = ({ children }) => {
  const [state, setState] = useState(DEFAULT_STATE)
	useEffect(() => {
    httpPost('footer/getAll')
      .then((res) => {
        setState({ footer: res.data })
      })
    getTranslate()
	}, [])

  const { instagram, facebook: telegram, youtube: viber } = ['instagram', 'facebook', 'youtube']
    .reduce((prevValue, currentValue) => {
      const link = (state.footer.find((el) => el.type === currentValue) || {}).title
      if (link) {
        return {
          ...prevValue,
          [currentValue]: link
        }
      }
      return prevValue
    }, {})
  const phone = (state.footer.find((item) => item.type === 'contacts') || {}).adds || ''
  const phoneOptions = (state.footer.filter((item) => item.type === 'contacts') || [])
    .map((item) => ({
      label: `${item.title} - ${item.adds}`,
      value: item.adds,
    }))
  const infoProps = {
    instagram,
    telegram,
    viber,
    phone,
    phoneOptions,
  }


  return <>
    <ScrollToTop />
    <Header {...infoProps} />
    <Breadcrumb />
    {children}
    <Footer {...infoProps} />
  </>
}



function mapStateToProps(state) {
  return {}
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch)
}


export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Template))
